import type { SEOPropsType } from '..';

export const SEO_CUSTOM_FORMULA_ACNE_CONTENT: SEOPropsType = {
  title: 'Custom Formula: Prescription Acne Treatment Cream | Curology',
  description:
    'Improve your skincare routine with Curology’s Custom Formula. Get a personalized formula tailored to your needs.',
};
